/**
 * Utility functions for generating helpdesk-specific URLs
 *
 * Note: URLs no longer include organization slug - unified multi-org view
 */

/**
 * Generate a helpdesk path
 */
export const getHelpdeskPath = (path: string = ''): string => {
  // Remove leading slash from path if present
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  return `/helpdesk${cleanPath ? `/${cleanPath}` : ''}`;
};

/**
 * Generate helpdesk URL for specific routes (unified multi-org view)
 */
export const getHelpdeskUrl = {
  dashboard: () => getHelpdeskPath('dashboard'),
  tickets: () => getHelpdeskPath('tickets'),
  ticket: (ticketId: string) => getHelpdeskPath(`tickets/${ticketId}`),
  newTicket: () => getHelpdeskPath('tickets/new'),
  customers: () => getHelpdeskPath('customers'),
  customer: (customerId: string) => getHelpdeskPath(`customers/${customerId}`),
  newCustomer: () => getHelpdeskPath('customers/new'),
  knowledgeBase: () => getHelpdeskPath('knowledge-base'),
  article: (articleId: string) => getHelpdeskPath(`knowledge-base/${articleId}`),
  newArticle: () => getHelpdeskPath('knowledge-base/new'),
  settings: () => getHelpdeskPath('settings'),
  profile: () => getHelpdeskPath('profile'),
  orgSettings: () => getHelpdeskPath('org-settings'),
  orgSettingsDetail: (orgId: string) => getHelpdeskPath(`org-settings/${orgId}`),
};

/**
 * Check if current path is a helpdesk route
 */
export const isHelpdeskRoute = (pathname: string): boolean => {
  return pathname.startsWith('/helpdesk');
};
